import React, { ReactNode, useContext } from "react";
import cx from "classnames";
import { Drawer } from "@geist-ui/core";
import { X } from "@geist-ui/icons";
import { ThemeContext } from "../Theme";
import styles from "./styles.module.scss";

export const GeistDrawer = ({
  openDrawer,
  onDrawerClosed,
  children,
  headline,
  disableBackdropClick = true,
}: {
  openDrawer: boolean;
  onDrawerClosed: () => void;
  children: ReactNode;
  headline: ReactNode;
  disableBackdropClick?: boolean;
}) => {
  const { isDarkMode } = useContext(ThemeContext);

  const handleClose = React.useCallback(() => {
    onDrawerClosed();
  }, [onDrawerClosed]);

  return (
    <Drawer
      className={cx(styles.drawer, {
        [styles.dark_mode]: isDarkMode,
        [styles.light_mode]: !isDarkMode,
      })}
      visible={openDrawer}
      onClose={handleClose}
      style={{ zIndex: 100000 }}
      disableBackdropClick={disableBackdropClick}
    >
      <div className={styles.header}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
        >
          <X />
        </button>
        <h3>{headline}</h3>
      </div>
      {children}
    </Drawer>
  );
};
